import { sentenceCase } from 'change-case'
import { FieldValues } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { FlexBox } from 'components/Box'
import { Switch } from 'components/Form'
import { SwitchProps } from 'components/Form/Switch'
import { SectionHeader } from 'components/Header'
import { TextLink } from 'components/Link'
import { KNOWLEDGE_BASE_URL } from 'features/globalSetup/features/amazon/constants'
import { Feature } from 'types/feature'

type Props<Schema extends FieldValues> = {
  Alerts: JSX.Element
  feature: Exclude<Feature, 'page'>
  switchProps: SwitchProps<Schema>
}

export const InventoryAmazonUamTamSectionHeader = <Schema extends FieldValues>({
  Alerts,
  feature,
  switchProps,
}: Props<Schema>): JSX.Element => {
  const { t } = useTranslation(['features/globalSetup/amazon', 'common'])

  return (
    <SectionHeader
      subtitle={t('inventory.uamTamSection.subtitle', { feature: sentenceCase(feature) })}
      subtitleEndAdornment={
        <TextLink
          link={{
            title: t('common:learnMore'),
            url: KNOWLEDGE_BASE_URL.AMAZON_UAM_TAM,
          }}
        />
      }
      title={t('inventory.uamTamSection.title')}
      titleEndAdornment={
        <FlexBox axis='x'>
          <Switch {...switchProps} />
          {Alerts}
        </FlexBox>
      }
    />
  )
}
